import { forwardRef } from "react";
import { useRecoilValue } from "recoil";
import { Body, BodyColor, BodyType } from "../../ui-elements";
import { hexLoadingState } from "../../states";

interface AggLayerOption {
    label: string;
    value: any;
    key: string;
}

interface AggLayerPopupProps {
    options: AggLayerOption[];
    selectedKey: string;
    position: { top: number; left: number };
    onSelect: (value: any) => void;
}

export const AggLayerPopup = forwardRef<HTMLDivElement, AggLayerPopupProps>(({ options, selectedKey, position, onSelect }, ref) => {
    const hexLoading = useRecoilValue(hexLoadingState);

    const renderOptionContent = (option: AggLayerOption) => {
        const isHexGrid = option.key === 'hexgrid';
        const showLoader = isHexGrid && hexLoading.loading && !hexLoading.firstChunkReceived;
        const isHexDisabled = isHexGrid && hexLoading.loading;

        return {
            content: (
                <div className="d-flex align-items-center gap-2 w-100">
                    <Body type={BodyType.p3} color={BodyColor.secondary} classname="p-0 m-0">
                        {option.label}
                    </Body>
                    {showLoader && (
                        <span className="spinner-border spinner-border-sm" role="status" aria-label="Loading hex data">
                            <span className="visually-hidden">Loading...</span>
                        </span>
                    )}
                    {/* {showProgress && (
                        <div className="d-flex align-items-center gap-1">
                            <div className="progress" style={{ width: '40px', height: '4px' }}>
                                <div
                                    className="progress-bar progress-bar-striped progress-bar-animated"
                                    role="progressbar"
                                    style={{ width: `${hexLoading.progress}%` }}
                                    aria-valuenow={hexLoading.progress}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                />
                            </div>
                            <span style={{ fontSize: '10px', color: '#6c757d' }}>{Math.round(hexLoading.progress)}%</span>
                        </div>
                    )} */}
                </div>
            ),
            isDisabled: isHexDisabled
        };
    };

    return (
        <div
            ref={ref}
            className="d-flex flex-column gap-2 bg-white rounded padding-2 shadow position-fixed"
            style={{ top: `${position.top}px`, left: `${position.left}px`, zIndex: 9999, minWidth: '150px' }}
        >
            {options.map((option) => {
                const { content, isDisabled } = renderOptionContent(option);
                return (
                    <label
                        key={option.key}
                        className="d-flex align-items-center gap-1"
                        style={{
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            opacity: isDisabled ? 0.6 : 1
                        }}
                    >
                        <input
                            type="radio"
                            name="aggLayerOption"
                            checked={selectedKey === option.key}
                            onChange={() => !isDisabled && onSelect(option.value)}
                            disabled={isDisabled}
                            style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                        />
                        {content}
                    </label>
                );
            })}
        </div>
    );
});
